import { MOBILE_E164_PATTERN, normalizeCodeInput, normalizeMobileField } from '@saay/formatting';

/** One pasted or uploaded line: mobile (09…) or 10-digit national code. */
export function parseBuyerIdentifierLines(text: string): {
  readonly mobileE164s: string[];
  readonly nationalCodes: string[];
} {
  const mobileE164s: string[] = [];
  const nationalCodes: string[] = [];
  const seen = new Set<string>();
  for (const line of text.split(/[\n,;]+/)) {
    const trimmed = line.trim();
    if (trimmed === '') continue;
    const digits = normalizeCodeInput(trimmed).replace(/\D/g, '');
    if (digits.length === 0) continue;
    if (/^09\d{9}$/.test(digits)) {
      const mobile = normalizeMobileField(digits);
      if (MOBILE_E164_PATTERN.test(mobile) && !seen.has(`m:${mobile}`)) {
        seen.add(`m:${mobile}`);
        mobileE164s.push(mobile);
      }
      continue;
    }
    if (/^\d{10}$/.test(digits) && !seen.has(`n:${digits}`)) {
      seen.add(`n:${digits}`);
      nationalCodes.push(digits);
    }
  }
  return { mobileE164s, nationalCodes };
}
